import { createFileRoute } from '@tanstack/react-router';
import { S10Inbox } from '@/screens/S10Inbox/S10Inbox';

export const Route = createFileRoute('/$orgId/inbox')({
  component: S10Inbox,
});
